<label class="container" [ngStyle]="{ padding: padding, margin: margin }">
	<ng-content></ng-content>
	<input
		type="checkbox"
		[checked]="checked"
		(change)="handleChange($any($event.target).checked)"
		(blur)="handleBlur()"
		[id]="id"
		[ngClass]="arrClasses"
		#checkBoxContainer
	/>
	<span class="checkmark"></span>
</label>
